import React, { useRef } from "react";
import { useScroll } from "framer-motion";
import { Section, Wrapper, SectionHead } from "../SectionHead";
import { Track, LineBase, LineProgress, Item, Node } from "./ExperienceStyle";
import ExperienceCard from "../Cards/ExperienceCard";
import { fadeUp, viewportOnce } from "../../utils/motion";
import { experiences } from "../../data/constants";

const Experience = () => {
  const trackRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: trackRef,
    offset: ["start center", "end center"],
  });

  return (
    <Section id="experience" style={{ scrollMarginTop: 96 }}>
      <Wrapper>
        <SectionHead
          eyebrow="Experience"
          title="Where I've worked since 2018, and what I built there."
          subtitle="Five roles, from backend engineering to leading architecture at Visiara Ltd."
        />

        <Track ref={trackRef}>
          <LineBase />
          <LineProgress style={{ scaleY: scrollYProgress }} />
          {experiences.map((experience, i) => (
            <Item
              key={experience.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
              custom={i}
            >
              <Node />
              <ExperienceCard experience={experience} />
            </Item>
          ))}
        </Track>
      </Wrapper>
    </Section>
  );
};

export default Experience;
